/*
 * @Descripttion: 组件业务名
 * @version:
 * @Author: lhl
 * @Date: 2022-03-09 17:48:40
 * @LastEditors: lhl
 * @LastEditTime: 2023-07-24 18:03:10
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base:
    process.env.CUSTOM_ENV === 'production'
      ? '/wap/lrb-zhkd-web/'
      : '/lrb-zhkd-web/',
  routes: [
    {
      path: '/',
      name: '/',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '盛投 (深圳) 供应链管理有限公司',
      },
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '盛投 (深圳) 供应链管理有限公司',
      },
    },
  ],
})

export default router
